const SalesStats = [
  ["Task", "Hours per Day"],
  ["Completed", 98],
  ["In Progress", 14],
  ["Returns", 3],
  ["Overdue Shipping", 1],
];
export default SalesStats;
